/* eslint-disable class-methods-use-this */
import React, { PureComponent } from "react";

import "../contractStyle.css";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Box } from "@mui/material";
import { IconButton } from "@material-ui/core";
import { Clear } from "@material-ui/icons";
import { connect } from "react-redux";
import { CheckedRadioGroup } from "../../../../shared/components/commonComponents/CheckedRadioGroup";
import { Button, ThemeActionButton } from "../../../../shared/widgets";

class BusinessDetails extends PureComponent {
  commonPasteHandler = (value) => {
    this.preventAlphaCharacter(
      value,
      value.nativeEvent.clipboardData.getData("Text"),
    );
  };

  renderThresholdInputFields = (errors, values, handleChange, i) => {
    if (values.unit) {
      return (
        <div>
          <Grid container spacing={4} className="customCheckboxWrapper">
            <Grid item sm={4}>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={values.is_threshold}
                    onChange={handleChange("is_threshold", "checked", null, i)}
                    name="is_threshold"
                  />
                )}
                label="Threshold"
              />
            </Grid>
          </Grid>
          {values.is_threshold && (
            <Grid container spacing={2} className="checkboxInput">
              <Grid item xs={3} className="selectWrapper">
                {values.unit === "perDay" && (
                  <FormControl className="">
                    <InputLabel
                      id="simple-select-label"
                      required
                      error={!!errors?.thresholdTypeBG}
                    >
                      Threshold
                    </InputLabel>
                    <Select
                      labelId="simple-select-label"
                      id="thresholdTypeBG"
                      value={values.thresholdTypeBG}
                      onChange={handleChange(
                        "thresholdTypeBG",
                        "event",
                        null,
                        i,
                      )}
                    >
                      <MenuItem value="epkm">EPKM</MenuItem>
                    </Select>
                  </FormControl>
                )}

                {values.unit === "perKm" && (
                  <FormControl className="">
                    <TextField
                      id="kmWiseThreshold"
                      label="Threshold Kilometer"
                      onKeyPress={(value) => {
                        this.preventAlphaCharacter(value, value.key);
                      }}
                      onPaste={(value) => {
                        this.commonPasteHandler(value);
                      }}
                      error={!!errors?.kmWiseThreshold}
                      helperText={errors?.kmWiseThreshold ? "Required" : ""}
                      defaultValue={values.kmWiseThreshold}
                      onChange={handleChange(
                        "kmWiseThreshold",
                        "event",
                        null,
                        i,
                      )}
                    />
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={3}>
                {values.unit === "perKm" && (
                  <FormControl className="">
                    <TextField
                      id="penalty"
                      label="Penalty ( INR )"
                      onKeyPress={(value) => {
                        this.preventAlphaCharacter(value, value.key);
                      }}
                      onPaste={(value) => {
                        this.commonPasteHandler(value);
                      }}
                      defaultValue={values.penalty}
                      error={!!errors?.penalty}
                      helperText={errors?.penalty ? "Required" : ""}
                      onChange={handleChange("penalty", "event", null, i)}
                    />
                  </FormControl>
                )}
                {values.thresholdTypeBG === "epkm"
                && values.unit === "perDay" && (
                  <FormControl className="">
                    <TextField
                      id="epkmBG"
                      label="EPKM ( INR )"
                      onKeyPress={(value) => {
                        this.preventAlphaCharacter(value, value.key);
                      }}
                      onPaste={(value) => {
                        this.commonPasteHandler(value);
                      }}
                      defaultValue={values.epkmBG}
                      error={!!errors?.epkmBG}
                      helperText={errors?.epkmBG ? "Required" : ""}
                      onChange={handleChange("epkmBG", "event", null, i)}
                    />
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={3}>
                {values.thresholdTypeBG === "epkm"
                  && values.unit === "perDay" && (
                  <FormControl className="">
                    <TextField
                      id="travelKmBG"
                      label="Distance Travel ( KM )"
                      onKeyPress={(value) => {
                        this.preventAlphaCharacter(value, value.key);
                      }}
                      onPaste={(value) => {
                        this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                      }}
                      defaultValue={values.travelKmBG}
                      error={!!errors?.travelKmBG}
                      helperText={errors?.travelKmBG ? "Required" : ""}
                      onChange={handleChange("travelKmBG", "event", null, i)}
                    />
                  </FormControl>
                )}
              </Grid>
            </Grid>
          )}
        </div>
      );
    }
    return null;
  };

  businessGuaranteedContractUI = (
    errors,
    values,
    handleChange,
    i,
  ) => (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={3} className="selectWrapper">
          <FormControl className="">
            <InputLabel id="baseline-label" required error={!!(errors?.unit)}>
              Criteria
            </InputLabel>
            <Select
              labelId="baseline-label"
              id="unit"
              value={values.unit}
              onChange={handleChange("unit", "event", null, i)}
            >
              <MenuItem value="perKm">Per Km</MenuItem>
              <MenuItem value="perDay">Per Day</MenuItem>
            </Select>
            <FormHelperText id="component-error-text" className="customHelper">
              {errors?.unit ? "Required" : ""}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl className="">
            {values.unit === "perDay" && (
              <TextField
                id="perDay"
                label="Amount ( INR )"
                error={!!(errors?.dayWisePaidAmount)}
                helperText={errors?.dayWisePaidAmount ? "Required" : ""}
                defaultValue={values.dayWisePaidAmount}
                onKeyPress={(value) => {
                  this.preventAlphaCharacter(value, value.key);
                }}
                onPaste={(value) => {
                  this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                }}
                onChange={handleChange("dayWisePaidAmount", "event", null, i)}
              />
            )}

            {values.unit === "perKm" && (
              <TextField
                id="perKm"
                label="Earning ( INR )"
                error={!!(errors?.kmWisePaidAmount)}
                onKeyPress={(value) => {
                  this.preventAlphaCharacter(value, value.key);
                }}
                onPaste={(value) => {
                  this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                }}
                helperText={errors?.kmWisePaidAmount ? "Required" : ""}
                defaultValue={values.kmWisePaidAmount}
                onChange={handleChange("kmWisePaidAmount", "event", null, i)}
              />
            )}
          </FormControl>
        </Grid>
      </Grid>
      {this.renderThresholdInputFields(errors, values, handleChange, i)}
      {(values.unit === "perDay" || values.unit === "perKm") && (
        <div>
          <Grid container spacing={4} className="customCheckboxWrapper">
            <Grid item xs={3}>
              <FormControlLabel
                control={(
                  <Checkbox
                    checked={values.is_capping}
                    onChange={handleChange("is_capping", "checked", null, i)}
                    name="is_capping"
                  />
                )}
                label="Max Loss"
              />
            </Grid>
          </Grid>
          {values.is_capping && (
            <Grid container spacing={2} className="checkboxInput">
              <Grid item xs={3}>
                <FormControl className="">
                  <TextField
                    id="cappingAmount"
                    label="Amount"
                    onKeyPress={(value) => {
                      this.preventAlphaCharacter(value, value.key);
                    }}
                    onPaste={(value) => {
                      this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                    }}
                    error={!!(errors?.cappingAmount)}
                    helperText={errors?.cappingAmount ? "Required" : ""}
                    defaultValue={values.cappingAmount}
                    onChange={handleChange("cappingAmount", "event", null, i)}
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}
        </div>
      )}
    </div>
  );

  revenueShareContractUI = (
    errors,
    values,
    handleChange,
    i,
  ) => (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={3} className="selectWrapper">
          <FormControl className="">
            <InputLabel id="criteria-label" error={!!(errors?.criteria)}>
              Criteria
            </InputLabel>
            <Select
              labelId="criteria-label"
              id="criteria"
              value={values.criteria}
              onChange={handleChange("criteria", "event", null, i)}
            >
              <MenuItem value="percentageBased">Percentage Based</MenuItem>
              <MenuItem value="perTicketBased">Per Ticket Based</MenuItem>
            </Select>
            <FormHelperText id="component-error-text" className="customHelper">
              {errors?.criteria ? "Required" : ""}
            </FormHelperText>
          </FormControl>
        </Grid>

        {values.criteria === "percentageBased" && (
          <Grid item xs={3} className="selectWrapper">
            <FormControl className="">
              <InputLabel id="collection-label" error={!!(errors?.percentageCriteria)}>
                Collection Type
              </InputLabel>
              <Select
                labelId="collection-label"
                id="percentageCriteria"
                value={values.percentageCriteria}
                onChange={handleChange("percentageCriteria", "event", null, i)}
              >
                <MenuItem value="totalCollection">Total Ticket Collection</MenuItem>
                <MenuItem value="cardCollection">Total Digital Collection</MenuItem>
                <MenuItem value="originalDigitalAmount">Original Digital Amount</MenuItem>
              </Select>
              <FormHelperText id="component-error-text" className="customHelper">
                {errors?.percentageCriteria ? "Required" : ""}
              </FormHelperText>
            </FormControl>
          </Grid>
        )}
        {values.criteria === "percentageBased" && (
          <Grid item xs={3} className="selectWrapper">
            <FormControl>
              <TextField
                id="percentage"
                label="Percentage"
                onKeyPress={(value) => {
                  this.preventAlphaCharacter(value, value.key);
                }}
                onPaste={(value) => {
                  this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                }}
                error={!!(errors?.percentage)}
                helperText={errors?.percentage ? "Required" : ""}
                defaultValue={values.percentage}
                onChange={handleChange("percentage", "event", null, i)}
              />
            </FormControl>
          </Grid>
        )}
        {values.criteria === "perTicketBased" && (
          <Grid item xs={3} className="selectWrapper">
            <FormControl className="">
              <InputLabel id="collection-label" error={!!(errors?.ticketCountType)}>
                Ticket Type
              </InputLabel>
              <Select
                labelId="collection-label"
                id="ticketCountType"
                value={values.ticketCountType}
                onChange={handleChange("ticketCountType", "event", null, i)}
              >
                <MenuItem value="totalTicketCount">Total Ticket Count</MenuItem>
                <MenuItem value="prepaidTicketCount">Digital Ticket Count</MenuItem>
                {/* <MenuItem value={"cashTicketCount"}>Cash Ticket Count</MenuItem> */}
              </Select>
              <FormHelperText id="component-error-text" className="customHelper">
                {errors?.ticketCountType ? "Required" : ""}
              </FormHelperText>
            </FormControl>
          </Grid>
        )}
        {values.criteria === "perTicketBased" && (
          <Grid item xs={3} className="selectWrapper">
            <FormControl>
              <TextField
                id="fee"
                label="Fee (INR)"
                onKeyPress={(value) => {
                  this.preventAlphaCharacter(value, value.key);
                }}
                onPaste={(value) => {
                  this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                }}
                error={!!(errors?.fee)}
                helperText={errors?.fee ? "Required" : ""}
                defaultValue={values.fee}
                onChange={handleChange("fee", "event", null, i)}
              />
            </FormControl>
          </Grid>
        )}
      </Grid>
    </div>
  );

  flatFeeContractUI = (
    errors,
    values,
    handleChange,
    i,
    subcriptionPlans,
    activeAddOns,
    CommercialsRadioData,
  ) => (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={3} className="selectWrapper">
          <FormControl className="">
            <InputLabel required id="criteria-label" error={!!errors?.flatFeeCriteria}>
              Criteria
            </InputLabel>
            <Select
              labelId="criteria-label"
              id="flatFeeCriteria"
              value={values.flatFeeCriteria}
              onChange={handleChange("flatFeeCriteria", "event", null, i)}
            >
              <MenuItem value="perDay">Per Day</MenuItem>
              <MenuItem value="perMonth">Per Month</MenuItem>
            </Select>
            <FormHelperText id="component-error-text" className="customHelper">
              {errors?.flatFeeCriteria ? "Required" : ""}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      {values.flatFeeCriteria && (
        <Grid container spacing={4}>
          <Grid item xs={3} className="selectWrapper">
            <FormControl className="">
              <InputLabel required id="flatFeeOn-label" error={!!errors?.flatFeeOn}>
                Flat Fee On
              </InputLabel>
              <Select
                labelId="flatFeeOn-label"
                id="flatFeeOn"
                value={values.flatFeeOn}
                onChange={handleChange("flatFeeOn", "event", null, i)}
              >
                <MenuItem value="perBus">Per Bus</MenuItem>
                {values.flatFeeCriteria === "perDay" && <MenuItem value="perRide">Per Ride</MenuItem>}
              </Select>
              <FormHelperText id="component-error-text" className="customHelper">
                {errors?.flatFeeOn ? "Required" : ""}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={3} className="selectWrapper">
            <FormControl>
              <TextField
                id="flatFee"
                required
                label="Fee (INR)"
                onKeyPress={(value) => {
                  this.preventAlphaCharacter(value, value.key);
                }}
                onPaste={(value) => {
                  this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                }}
                error={!!(errors?.flatFee)}
                helperText={errors?.flatFee ? "Required" : ""}
                defaultValue={values.flatFee}
                onChange={handleChange("flatFee", "event", null, i)}
              />
            </FormControl>
          </Grid>
        </Grid>
      )}
      {values.flatFeeOn === "perRide" && (
        <Grid container spacing={4}>
          <Grid item xs={3} className="selectWrapper">
            <FormControl>
              <TextField
                required
                id="minimumRides"
                label="Minimum Rides"
                onKeyPress={(value) => {
                  this.preventAlphaCharacter(value, value.key);
                }}
                onPaste={(value) => {
                  this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                }}
                error={!!(errors?.minimumRides)}
                helperText={errors?.minimumRides ? "Required" : ""}
                defaultValue={values.minimumRides}
                onChange={handleChange("minimumRides", "event", null, i)}
              />
            </FormControl>
          </Grid>
        </Grid>
      )}
      {values.flatFeeOn === "perBus" && (
        <>
          <Grid container spacing={4}>
            <Grid key={subcriptionPlans.name} container item alignItems="flex-end">
              <Grid item xs={12} sm={4}>
                <Box sx={{ fontWeight: "bold" }}>{subcriptionPlans.label}</Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <CheckedRadioGroup
                  options={subcriptionPlans.option}
                  onChangeHandler={handleChange(subcriptionPlans.name, "event", null, i)}
                  defaultValue={subcriptionPlans.defaultValue}
                  name={subcriptionPlans.name}
                />
              </Grid>
              {/* <Grid item xs={12} sm={2}>
                  <Box sx={{ fontWeight: 'bold' }}>See Plan Details</Box>
                </Grid> */}
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={3} className="selectWrapper">
              <FormControl className="">
                <InputLabel id="criteria-label">
                  Select Add Ons
                </InputLabel>
                <Select
                  labelId="criteria-label"
                  id="selectedAddOns"
                  value=""
                  onChange={handleChange("selectedAddOns", "event", null, i)}
                >
                  {activeAddOns.map(
                    (addOn) => (
                      <MenuItem key={addOn.addOnName + addOn.addOnId} value={addOn.addOnId}>
                        {addOn.addOnName}
                      </MenuItem>
                    ),
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={9}>
              {values.selectedAddOns?.length === 0
                ? ""
                : values.selectedAddOns?.map((item) => (
                  <Box
                    key={item}
                    sx={{
                      display: "inline",
                    }}
                  >
                    {activeAddOns.find((addOn) => addOn.addOnId === item).addOnName}
                    <IconButton
                      onClick={handleChange("selectedAddOns", "event", { isRemove: true, value: item }, i)}
                      color="red"
                    >
                      <Clear fontSize="medium" style={{ color: "#f47c21" }} />
                    </IconButton>
                  </Box>
                ))}
            </Grid>
          </Grid>
        </>
      )}
      <Grid container spacing={4}>
        {CommercialsRadioData.map((item) => (
          <Grid key={item.name} container item alignItems="flex-end">
            <Grid item xs={12} sm={6} md={4}>
              <Box sx={{ fontWeight: "bold" }}>{item.label}</Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <CheckedRadioGroup
                options={item.option}
                onChangeHandler={handleChange(item.name, "event", null, i)}
                defaultValue={item.defaultValue}
                name={item.name}
              />
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );

  baselineContractUI = (
    errors,
    values,
    handleChange,
    i,
    addClick,
    removeClick,
  ) => (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={3} className="selectWrapper">
          <FormControl className="">
            <InputLabel id="criteria-label" error={!!(errors?.baselineCriteria)}>
              Criteria
            </InputLabel>
            <Select
              labelId="criteria-label"
              id="baselineCriteria"
              value={values.baselineCriteria}
              onChange={handleChange("baselineCriteria", "event", null, i)}
            >
              <MenuItem value="percentageBased">Percentage Based</MenuItem>
              <MenuItem value="flatFeeBased">Flat Fee Based</MenuItem>
            </Select>
            <FormHelperText id="component-error-text" className="customHelper">
              {errors?.baselineCriteria ? "Required" : ""}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      {values.baselinePercentage.map((One, index) => {
        const error = errors?.baselinePercentage?.length > 0
          && errors.baselinePercentage[index];
        return (
          <div key={One.baseline}>
            <Grid container spacing={4}>
              <Grid item xs={3} className="selectWrapper">
                <FormControl>
                  <TextField
                    id="baseline"
                    label="Baseline Amount"
                    onKeyPress={(value) => {
                      this.preventAlphaCharacter(value, value.key);
                    }}
                    onPaste={(value) => {
                      this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                    }}
                    error={!!(error?.baseline)}
                    helperText={error?.baseline ? "Required" : ""}
                    defaultValue={One.baseline}
                    onChange={handleChange("baseline", "nested", index, i)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} className="selectWrapper">
                <FormControl className="">
                  <InputLabel id="collection-label" error={!!(error?.percentageCriteria)}>
                    Collection Type
                  </InputLabel>
                  <Select
                    labelId="collection-label"
                    error
                    id="percentageCriteria"
                    value={One.percentageCriteria}
                    onChange={handleChange("percentageCriteria", "nested", index, i)}
                  >
                    <MenuItem value="totalCollection">Total Ticket Collection</MenuItem>
                    <MenuItem value="cardCollection">Total Digital Collection</MenuItem>
                    <MenuItem value="originalDigitalAmount">Original Digital Amount</MenuItem>
                  </Select>
                  <FormHelperText id="component-error-text" className="customHelper">
                    {error?.percentageCriteria ? "Required" : ""}
                  </FormHelperText>
                </FormControl>
              </Grid>
              {values.baselineCriteria === "percentageBased" && (
                <Grid item xs={2} className="selectWrapper">
                  <FormControl>
                    <TextField
                      id="percentage"
                      label="Percentage"
                      onKeyPress={(value) => {
                        this.preventAlphaCharacter(value, value.key);
                      }}
                      onPaste={(value) => {
                        this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                      }}
                      error={!!(error?.percentage)}
                      helperText={error?.percentage ? "Required" : ""}
                      defaultValue={One.percentage}
                      onChange={handleChange("percentage", "nested", index, i)}
                    />
                  </FormControl>
                </Grid>
              )}
              {values.baselineCriteria === "flatFeeBased" && (
                <Grid item xs={2} className="selectWrapper">
                  <FormControl>
                    <TextField
                      id="baselineFlatFee"
                      label="Flat fee"
                      onKeyPress={(value) => {
                        this.preventAlphaCharacter(value, value.key);
                      }}
                      onPaste={(value) => {
                        this.preventAlphaCharacter(value, value.nativeEvent.clipboardData.getData("Text"));
                      }}
                      error={!!(error?.baselineFlatFee)}
                      helperText={error?.baselineFlatFee ? "Required" : ""}
                      defaultValue={One.baselineFlatFee}
                      onChange={handleChange("baselineFlatFee", "nested", index, i)}
                    />
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={2} className="selectWrapper">
                {index === values.baselinePercentage.length - 1 && (
                  <Button
                    classname="removeBtnContainer"
                    onClick={() => {
                      addClick("baselinePercentage", i);
                    }}
                    buttonText="Add +"
                  />
                )}
              </Grid>
              <Grid item xs={2} className="selectWrapper">
                {index !== 0 && (
                  <Button
                    classname="removeBtnContainer"
                    onClick={() => {
                      removeClick(i, "baselinePercentage", index);
                    }}
                    buttonText="Remove"
                  />
                )}
              </Grid>
            </Grid>
          </div>
        );
      })}
    </div>
  );

  preventAlphaCharacter(event, value) {
    const re = /^[ 0-9.]*$/;
    if (!re.test(value)) {
      event.preventDefault();
    }
  }

  createUI() {
    const {
      values: state, activePlans, activeAddOns, handleChange, removeClick, addClick,
    } = this.props;
    const { businessDetailError } = state;
    const contractTypes = {
      businessGuaranteed: "Business Guarantee",
      revenueShare: "Revenue Share",
      flatFee: "Flat Fee",
      baseline: "Baseline",
    };
    return state.businessDetails.map((values, i) => {
      const errors = businessDetailError?.length > 0 && businessDetailError[i];
      const updatedContractTypes = Object.keys(contractTypes).filter((selectedOption) => {
        const isOptionIncluded = state.businessDetails.some(
          (item) => item.contractType === selectedOption,
        );
        const isOptionSameAsCurrent = selectedOption === values.contractType;
        return !isOptionIncluded || isOptionSameAsCurrent;
      });
      const CommercialsRadioData = [
        {
          label: "Days to include",
          option: [
            { label: "Waybill Days", value: "waybillDays" },
            { label: "Calendar Days", value: "calendarDays" },
          ],
          defaultValue: values.daysToInclude || "waybillDays",
          name: "daysToInclude",
        },
      ];
      const subcriptionPlans = {
        label: "Subscription Plan",
        option: activePlans.map((plan) => ({ label: plan.planName, value: plan.planId })),
        defaultValue: values.subscriptionPlan || 1,
        name: "subscriptionPlan",
      };

      return (
        <div className="businessWrapper" key={i}>
          <div className="sub-heading">
            <span>Chose Contract Type</span>
          </div>
          <Grid container spacing={2}>
            <div className="expand">
              <Grid item xs={3} className="selectWrapper">
                <FormControl>
                  <InputLabel
                    id="demo-simple-select-label"
                    required
                    error={!!(errors?.contractType)}
                  >
                    Contract Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={values.contractType}
                    onChange={handleChange("contractType", "event", null, i)}
                  >
                    {updatedContractTypes.map((contractType) => <MenuItem key="" value={contractType}>{contractTypes[contractType]}</MenuItem>)}
                  </Select>
                  <FormHelperText id="component-error-text" className="customHelper">
                    {errors?.contractType ? "Required" : ""}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </div>
            {i !== 0 && (
              <Button
                classname="removeBtnContainer"
                onClick={() => {
                  removeClick(i);
                }}
                buttonText="Remove"
              />
            )}
          </Grid>
          {values.contractType === "businessGuaranteed" && (this.businessGuaranteedContractUI(errors, values, handleChange, i))}
          {values.contractType === "revenueShare" && (this.revenueShareContractUI(errors, values, handleChange, i))}
          {values.contractType === "flatFee" && (this.flatFeeContractUI(
            errors,
            values,
            handleChange,
            i,
            subcriptionPlans,
            activeAddOns,
            CommercialsRadioData,
          ))}
          {values.contractType === "baseline" && (this.baselineContractUI(
            errors,
            values,
            handleChange,
            i,
            addClick,
            removeClick,
          ))}
        </div>
      );
    });
  }

  render() {
    const { addClick } = this.props;
    return (
      <div>
        {this.createUI()}
        <ThemeActionButton
          classname="removeBtnContainer"
          onClick={() => {
            addClick("businessDetails");
          }}
          buttonText="Add Contract Type"
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activePlans: state?.Contracts?.subscriptonPlansDetail?.activePlans || [],
    activeAddOns: state?.Contracts?.subscriptonPlansDetail?.activeAddOns || [],
  };
}

export default connect(mapStateToProps, null)(BusinessDetails);
